/* Longeva — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function countUp(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    if (!/^\s*[\d.,]+\s*$/.test(el.dataset.target || '')) return;
    var raw = (el.dataset.target || '').replace(/\./g, '').replace(',', '.');
    var target = parseFloat(raw);
    if (isNaN(target) || reduce) return;
    var original = el.textContent;
    var start = null, dur = 1400;
    var fmt = new Intl.NumberFormat('es-ES');
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt.format(Math.round(target * e));
      if (p < 1) requestAnimationFrame(step); else el.textContent = original;
    }
    requestAnimationFrame(step);
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lg-fade, .lg-stagger, .lg-reveal');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('lg-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('lg-in');
          en.target.querySelectorAll('.lg-count').forEach(countUp);
          io.unobserve(en.target);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-lg-product]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var dataEl = wrap.querySelector('[data-lg-variants]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants;
      var input = wrap.querySelector('input[name="id"]');
      var btn = wrap.querySelector('[data-lg-add]');
      var btnLabel = wrap.querySelector('[data-lg-add-label]');
      var priceEl = wrap.querySelector('[data-lg-price]');
      var wasEl = wrap.querySelector('[data-lg-was]');
      var saveEl = wrap.querySelector('[data-lg-save]');
      var unitEl = wrap.querySelector('[data-lg-unit]');
      var mainImg = wrap.querySelector('[data-lg-main]');
      var thumbs = wrap.querySelectorAll('[data-lg-thumb]');
      var groups = wrap.querySelectorAll('[data-lg-option]');

      function selected() {
        var sel = [];
        groups.forEach(function (g) {
          var b = g.querySelector('[aria-pressed="true"]');
          sel.push(b ? b.dataset.value : null);
        });
        return sel;
      }
      function find(sel) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function showMedia(id) {
        thumbs.forEach(function (t) {
          var on = t.dataset.mediaId === String(id);
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && mainImg) { mainImg.src = t.dataset.full; mainImg.srcset = ''; }
        });
      }
      function update() {
        var sel = selected();
        var v = find(sel);
        // marcar combinaciones no disponibles
        groups.forEach(function (g, gi) {
          g.querySelectorAll('[data-value]').forEach(function (b) {
            var test = sel.slice(); test[gi] = b.dataset.value;
            var m = find(test);
            b.dataset.unavailable = (!m || !m.available) ? 'true' : 'false';
          });
          var cur = g.querySelector('[data-lg-current]');
          if (cur) cur.textContent = sel[gi] || '';
        });
        if (!v) {
          btn.disabled = true; btnLabel.textContent = data.unavailable; return;
        }
        input.value = v.id;
        btn.disabled = !v.available;
        btnLabel.textContent = v.available ? data.add : data.soldout;
        if (priceEl) priceEl.textContent = money(v.price, data.format);
        if (wasEl) {
          wasEl.hidden = !(v.compare_at_price > v.price);
          if (v.compare_at_price > v.price) wasEl.textContent = money(v.compare_at_price, data.format);
        }
        var units = parseInt(v.units, 10) || 1;
        if (saveEl) {
          var save = data.single_price * units - v.price;
          saveEl.hidden = !(units > 1 && save > 0);
          if (units > 1 && save > 0) saveEl.textContent = data.save_label.replace('[x]', money(save, data.format));
        }
        if (unitEl) unitEl.textContent = units > 1 ? data.unit_label.replace('[x]', money(Math.round(v.price / units), data.format)) : '';
        if (v.media_id) showMedia(v.media_id);
        if (window.history && window.history.replaceState && !wrap.closest('.shopify-design-mode')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      groups.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('[data-value]');
          if (!b) return;
          g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          update();
        });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
      });
      if (groups.length) update();
    });
  }

  function init(root) { initReveal(root); initProduct(root); }

  document.documentElement.classList.add('lg-js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
